/* NOVAH lazy background video loader.
   - Videos render poster-only at first paint (no bytes fetched: preload="none", no autoplay attr).
   - Sources attach + playback starts only when the video scrolls near the viewport.
   - prefers-reduced-motion: video never loads; poster stays.
   - Pauses when scrolled out of view (battery/CPU).
   - Wires optional [data-novah-video-toggle] pause/play buttons (WCAG 2.2.2).
   Idempotent: safe to include more than once. */
(function () {
  if (window.__novahLazyVideo) return;
  window.__novahLazyVideo = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function attach(video) {
    if (video.dataset.novahLoaded) return;
    video.dataset.novahLoaded = '1';
    var src = video.dataset.src;
    if (!src) return;
    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.load();
  }

  function play(video) {
    if (reduced.matches) return; // poster-only for reduced motion
    if (video.dataset.novahUserPaused === '1') return;
    attach(video);
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // The desktop/mobile twin that is display:none never loads (saves its bytes).
  function shown(v) { return v.offsetParent !== null || getComputedStyle(v).position === 'fixed'; }

  function init() {
    var videos = Array.prototype.slice.call(document.querySelectorAll('video[data-novah-lazy]'));
    if (!videos.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            // Skip elements that are display:none (e.g. the desktop/mobile twin)
            if (!shown(v)) return;
            play(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px' });
      videos.forEach(function (v) { io.observe(v); });
    } else {
      videos.forEach(play);
    }

    // Pause/play toggles
    Array.prototype.forEach.call(document.querySelectorAll('[data-novah-video-toggle]'), function (btn) {
      var card = btn.closest('[data-novah-video-card]') || btn.parentElement;
      var vids = card ? card.querySelectorAll('video[data-novah-lazy]') : [];
      if (!vids.length) return;
      btn.addEventListener('click', function () {
        var anyPlaying = Array.prototype.some.call(vids, function (v) { return !v.paused; });
        Array.prototype.forEach.call(vids, function (v) {
          if (anyPlaying) {
            v.dataset.novahUserPaused = '1';
            v.pause();
          } else {
            v.dataset.novahUserPaused = '';
            if (shown(v)) play(v);
          }
        });
        btn.setAttribute('aria-pressed', anyPlaying ? 'true' : 'false');
        btn.setAttribute('aria-label', anyPlaying ? 'Play background video' : 'Pause background video');
        btn.classList.toggle('is-paused', anyPlaying);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
